"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconCake = Experimental__IconCake;
exports.IconCake = IconCake;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconCake/index.tsx)
 */
function IconCake(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M9.5 2.4c0 .74-.302 1.207-.75 1.434v1.49h4.5c.966 0 1.75.784 1.75 1.75v1.917c0 .74-.284 1.415-.75 1.92v3.839c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25v-3.839A2.823 2.823 0 0 1 1 8.991V7.074c0-.966.784-1.75 1.75-1.75h4.5v-1.49C6.802 3.607 6.5 3.14 6.5 2.4c0-.937.809-1.723 1.284-2.184A8.73 8.73 0 0 0 8 0c.057.06.131.133.216.216C8.691.677 9.5 1.463 9.5 2.4Zm-6.25 9.364V14.5h9.5v-2.736c-.188.04-.383.06-.583.06h-.094a2.732 2.732 0 0 1-1.975-.84 2.823 2.823 0 0 1-2.098.93c-.832 0-1.58-.359-2.098-.93-.499.518-1.2.84-1.975.84h-.094c-.2 0-.395-.02-.583-.06Zm6.833-3.43a.75.75 0 0 1 .75.75c0 .685.556 1.24 1.24 1.24h.094c.736 0 1.333-.597 1.333-1.333V7.074a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25v1.917c0 .736.597 1.333 1.333 1.333h.094a1.24 1.24 0 0 0 1.24-1.24.75.75 0 0 1 .75-.75h.003a.75.75 0 0 1 .75.75 1.33 1.33 0 1 0 2.66 0 .75.75 0 0 1 .75-.75h.003Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13 5.793c.598-.284 1-.868 1-1.793 0-1.17-1.079-2.154-1.711-2.73-.114-.104-.213-.194-.289-.27-.076.076-.175.166-.289.27C11.08 1.846 10 2.83 10 4c0 .925.402 1.509 1 1.793V7.9H5a3 3 0 0 0-2.993 2.8H2v2.4a3.99 3.99 0 0 0 1 2.646V21a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5.254c.622-.705 1-1.632 1-2.646v-2.4h-.007A3 3 0 0 0 19 7.9h-6V5.793ZM5 9.9h14a1 1 0 0 1 1 1v2.2a2 2 0 1 1-4 0V13a1 1 0 0 0-2 0v.1a2 2 0 1 1-4 0V13a1 1 0 0 0-2 0v.1a2 2 0 1 1-4 0v-2.2a1 1 0 0 1 1-1Zm14 7.074V21H5v-4.026a4.006 4.006 0 0 0 4-1.228 3.99 3.99 0 0 0 3 1.354 3.99 3.99 0 0 0 3-1.354 3.99 3.99 0 0 0 4 1.228Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconCake is deprecated and will be archived soon. Use IconCake instead.
 */
function Experimental__IconCake(props) {
  return /*#__PURE__*/_react["default"].createElement(IconCake, props);
}